export default __webpack_public_path__ + "static/media/Exaltate's Helm.aa18681b.jpg";